var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 790.943,
    height: 614.547,
    viewBox: "0 0 790.943 614.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d30001"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17484",
    "data-name": "Group 17484",
    transform: "translate(-489.303 -186.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Mobile_app_p3ts",
    transform: "translate(489.303 186.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M676.918,424.375,519.844,228.091a52.737,52.737,0,0,1-25.4,12.827c-29.571,5.824-58.449-14.37-64.5-45.1-4.279-21.725,4-42.89,19.667-55.495L396.048,73.392,90.923,334.168l280.87,350.983Z",
    transform: "translate(-90.923 -73.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M0,0H723.965",
    transform: "translate(66.978 613.547)",
    fill: "none",
    stroke: "#3f3d56",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 12.03,
    cy: 12.03,
    r: 12.03,
    transform: "translate(492.976 34.372)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 12.03,
    cy: 12.03,
    r: 12.03,
    transform: "translate(651.955 384.126)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 12.03,
    cy: 12.03,
    r: 12.03,
    transform: "translate(127.134 64.538)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 44.282,
    cy: 44.282,
    r: 44.282,
    transform: "translate(346.542 69.636)",
    fill: "rgba(1,26,67,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M241.942,182.772H438.11a41.7,41.7,0,0,1,40.68,32.53l99.12,439.652a33.7,33.7,0,0,1-31.22,41.075l-201.662,9.936a44.526,44.526,0,0,1-46.006-36.547L242.795,358.579l-4.183,1.2-10.759-58.916,4.306-1.076-15.695-86.766a25.675,25.675,0,0,1,25.478-30.245Z",
    transform: "translate(-114.038 -93.597)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M416.671,194.4h22.9a28.819,28.819,0,0,1,28.156,22.676l95.142,436.065a17.857,17.857,0,0,1-16.279,21.626l-201.01,13.174a23.127,23.127,0,0,1-24.273-18.978L240.121,218.244A20.256,20.256,0,0,1,260.057,194.4H281.78a9.56,9.56,0,0,1,9.231,7.074h0a8.44,8.44,0,0,0,8.149,6.246H402.287a14.427,14.427,0,0,0,14.384-13.32Z",
    transform: "translate(-118.424 -95.745)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 30.002,
    cy: 30.002,
    r: 30.002,
    transform: "translate(534.946 161.52)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M729.514,695.325l5.707,24.458h-13.86l-5.707-27.719Z",
    transform: "translate(-132.198 -127.841)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M647.514,696.064v22.828l-13.86,1.631V696.064Z",
    transform: "translate(-117.051 -128.58)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M822.481,451.272s-1.63,35.057-3.261,37.5-16.305,37.5-16.305,37.5l-7.338-22.828s11.414-18.751,9.783-29.35-.6-23.641-.6-23.641Z",
    transform: "translate(-221.089 -143.045)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 22.828,
    cy: 22.828,
    r: 22.828,
    transform: "translate(532.093 177.782)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M788.3,322.456s-.815,32.611,4.892,37.5-32.611.815-32.611.815,8.153-22.828,1.631-27.719S788.3,322.456,788.3,322.456Z",
    transform: "translate(-214.624 -119.4)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M746.519,365.6s4.892-8.968,11.414-8.153,27.719,2.446,28.535,4.076,3.261,7.338,4.892,8.968,13.86,4.076,14.675,13.86-29.35,69.3-29.35,69.3,4.076,13.86,3.261,17.121,4.076,13.044,3.261,17.121,12.229,28.535,5.707,60.33v51.362s22.012,88.865,15.49,95.387-28.535,2.446-32.611,0-21.2-125.552-21.2-125.552l-8.153-41.579-.815,91.311s1.631,76.636-4.076,79.082-27.719,3.261-29.35-1.631c-1.272-3.815-7.5-105.324-10.183-149.82a166.243,166.243,0,0,1,3.589-45.8c3.393-15.391,8.32-33.473,13.932-40.811,10.6-13.86,17.121-57.885,17.121-57.885L718.8,377.011s8.153-8.153,13.044-8.153S746.519,365.6,746.519,365.6Z",
    transform: "translate(-203.012 -125.854)",
    fill: "#011a43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M820.972,383.456l4.3,2.926s3.038,52.512.592,55.774-19.45,1.67-20.731-1.2S820.972,383.456,820.972,383.456Z",
    transform: "translate(-222.842 -130.668)",
    fill: "#011a43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M718.72,440.987c2.386,16.555,4.478,31.293-7.725,44.626A228.98,228.98,0,0,1,669.8,521.3c-1.5,3.965-23.468,33.078-24.586,21.465s6.473-20.717,17.261-30.537,25.879-31.128,34.394-42.819,5.01-18.982,4.714-28.747S715.372,441.1,718.72,440.987Z",
    transform: "translate(-193.293 -140.454)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M721.975,781.255s-.815,9.132-3.261,11.578-8.968,5.707-8.153,14.675,6.115,9.376,6.115,9.376l-.408-2.038,2.446.815.408,1.223h22.828s.408-8.56-.408-12.637-.815-23.643-3.261-22.828-8.968,1.63-10.6,4.892S721.16,788.429,721.975,781.255Z",
    transform: "translate(-205.372 -204.151)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M822.028,781.255s.815,9.132,3.261,11.578,8.968,5.707,8.153,14.675-6.115,9.376-6.115,9.376l.408-2.038-2.446.815-.408,1.223H802.054s-.408-8.56.408-12.637.815-23.643,3.261-22.828,8.968,1.63,10.6,4.892S822.843,788.429,822.028,781.255Z",
    transform: "translate(-222.267 -204.151)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M732.64,378.456,721.226,380.9s0,17.936-3.261,25.274-8.968,24.458-6.522,25.274,25.274,12.229,26.9,5.707S744.054,378.456,732.64,378.456Z",
    transform: "translate(-205.438 -129.745)",
    fill: "#011a43"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 30.002,
    cy: 30.002,
    r: 30.002,
    transform: "translate(567.449 122.017)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M844.987,283.971a30,30,0,0,1-46.331-15.754,30,30,0,1,0,58.526-12.3,29.992,29.992,0,0,1-12.195,28.057Z",
    transform: "translate(-221.658 -107.108)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 22.001,
    cy: 22.001,
    r: 22.001,
    transform: "translate(550.948 174.521)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 19.501,
    cy: 15.251,
    rx: 19.501,
    ry: 15.251,
    transform: "translate(534.946 173.021)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 3.701,
    cy: 6.548,
    rx: 3.701,
    ry: 6.548,
    transform: "translate(545.545 197.351)",
    fill: "#a0616a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M3.6,2.868s27.586-27.45,46.611-23.093S46.057,45.054,56.02,47.335c26.567,6.084,49.551-23.282,49.551-23.282L117.442,113.5-15.346,276.558Z",
    transform: "matrix(0.616, -0.788, 0.788, 0.616, 723.408, 542.991)",
    opacity: 0.147
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5244-6-3-8-3-9-4-9-9-6-3",
    transform: "translate(719.412 479.985) rotate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5223-8-3-1-0-5-3-0-0-9-9-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M304.439,101.6c-9.01,0-17.79-5.241-22.666-14.02l-.09-.165c-6.378-12.109-7.191-13.618-7.978-15.074-.806-1.494-1.641-3.039-8.009-15.131-2.429-4.309-6.575-5.794-9.436-5.025-.825.22-3.02.808-2.967,5.146l.721,40.245-16.916.3-.721-40.291c-.134-10.712,5.96-19.259,15.525-21.819,10.9-2.918,22.663,2.527,28.61,13.239l.089.165c6.374,12.1,7.189,13.611,7.978,15.071.842,1.562,1.637,3.034,8.009,15.134,2.429,4.309,6.576,5.791,9.436,5.027.827-.222,3.022-.809,2.967-5.146l-.72-38.54,16.915-.319L325.909,79c.134,10.718-5.96,19.265-15.524,21.825A22.97,22.97,0,0,1,304.439,101.6Z",
    transform: "translate(-236.375 -34.995)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogin);
export default __webpack_public_path__ + "static/media/mobileLogin.740f090f0cae2282ed131444470f6e38.svg";
export { ForwardRef as ReactComponent };